import { render, staticRenderFns } from "./staffEditTabInformation.vue?vue&type=template&id=9152aa76&scoped=true&"
import script from "./staffEditTabInformation.vue?vue&type=script&lang=js&"
export * from "./staffEditTabInformation.vue?vue&type=script&lang=js&"
import style0 from "./staffEditTabInformation.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9152aa76",
  null
  
)

export default component.exports